var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #bcbccb;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chat_Icon",
    "data-name": "Chat Icon",
    className: "cls-1",
    d: "M-1231.866,4.363a9.93,9.93,0,0,1-1.634.137,9.108,9.108,0,0,1-4.757-1.276c.128,0,.252.026.381.026,5.2,0,9.53-3.316,10.442-7.674a4.735,4.735,0,0,1,1.433,3.3A4.674,4.674,0,0,1-1227.264,2h.015V7Zm-12.884-6.836A6.09,6.09,0,0,1-1246-6.124c0-3.8,3.637-6.875,8.125-6.875s8.125,3.077,8.125,6.875-3.637,6.875-8.125,6.875a9.318,9.318,0,0,1-3.5-.677L-1244.75,2Z",
    transform: "translate(1246 13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.f413a529a37d5014f171216ea6fb8a57.svg";
export { ForwardRef as ReactComponent };